import { render } from "./component-card-expl-id-vg.vue?vue&type=template&id=7893dc8a"
import script from "./component-card-expl-id-vg.vue?vue&type=script&setup=true&lang=js"
export * from "./component-card-expl-id-vg.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/e-grid/eosrc-card/field-wrappers/component-card-expl-id-vg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7893dc8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7893dc8a', __exports__)) {
    api.reload('7893dc8a', __exports__)
  }
  
  module.hot.accept("./component-card-expl-id-vg.vue?vue&type=template&id=7893dc8a", () => {
    api.rerender('7893dc8a', render)
  })

}


export default __exports__